var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('order-input',{attrs:{"order":_vm.order},model:{value:(_vm.shoppingCard),callback:function ($$v) {_vm.shoppingCard=$$v},expression:"shoppingCard"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }